export interface WithdrawalErrorMessage {
  ru: string;
  en: string;
}

export const WITHDRAWAL_ERROR_MESSAGES: Record<string, WithdrawalErrorMessage> =
  {
    "The confirmation code is not correct!": {
      ru: "Неверный код подтверждения!",
      en: "The confirmation code is not correct!",
    },
    "Failed to process withdrawal confirmation request!": {
      ru: "Не удалось обработать запрос на подтверждение вывода!",
      en: "Failed to process withdrawal confirmation request!",
    },
    "Insufficient balance for withdrawal": {
      ru: "Недостаточно средств",
      en: "Insufficient balance for withdrawal",
    },
    "Invalid recipient address": {
      ru: "Некорректный адрес получателя",
      en: "Invalid recipient address",
    },
    "Withdrawal amount is below minimum limit": {
      ru: "Сумма меньше минимальной",
      en: "Withdrawal amount is below minimum limit",
    },
    "Withdrawal amount exceeds maximum limit": {
      ru: "Сумма превышает максимальную",
      en: "Withdrawal amount exceeds maximum limit",
    },
    "Withdrawals are temporarily suspended": {
      ru: "Выводы временно приостановлены",
      en: "Withdrawals are temporarily suspended",
    },
    "Invalid currency for withdrawal": {
      ru: "Неподдерживаемая валюта",
      en: "Invalid currency for withdrawal",
    },
    "Invalid network for withdrawal": {
      ru: "Неподдерживаемая сеть",
      en: "Invalid network for withdrawal",
    },
    "Withdrawal failed. Please try again later": {
      ru: "Ошибка при выполнении вывода. Попробуйте позже",
      en: "Withdrawal failed. Please try again later",
    },
    "Network error. Please check your connection and try again": {
      ru: "Ошибка сети. Проверьте соединение и попробуйте снова",
      en: "Network error. Please check your connection and try again",
    },
    "Rate limit exceeded. Please try again later": {
      ru: "Превышен лимит запросов. Попробуйте позже",
      en: "Rate limit exceeded. Please try again later",
    },
    "Service temporarily unavailable due to maintenance": {
      ru: "Сервис на техническом обслуживании",
      en: "Service temporarily unavailable due to maintenance",
    },
    "KYC verification required for withdrawals": {
      ru: "Требуется верификация KYC",
      en: "KYC verification required for withdrawals",
    },
    "Two-factor authentication required for withdrawals": {
      ru: "Требуется двухфакторная аутентификация",
      en: "Two-factor authentication required for withdrawals",
    },
    "Withdrawal completed successfully": {
      ru: "Вывод успешно выполнен",
      en: "Withdrawal completed successfully",
    },
  };

export function getWithdrawalErrorMessage(
  errorMessage: string,
  language: "ru" | "en" = "en"
): string {
  const errorData = WITHDRAWAL_ERROR_MESSAGES[errorMessage];

  if (errorData) {
    return errorData[language];
  }

  return errorMessage;
}

export function getWithdrawalErrorMessages(
  errorMessage: string
): WithdrawalErrorMessage {
  const errorData = WITHDRAWAL_ERROR_MESSAGES[errorMessage];

  if (errorData) {
    return errorData;
  }

  return {
    ru: errorMessage,
    en: errorMessage,
  };
}
